/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { Component } from "react"
// import PropTypes from "prop-types"
import { breakpoints } from "../../constants/global"
import StoreList from "./StoreList"
import StoreDetails from "./StoreDetails"
import SearchBox from "./SearchBox"
import Map from "./Map"
import styles from "../../styles/components/StoreLocator/ChinaStoreLocator-tw-styles"
import mapStyle from "./mapStyle"
import { connect } from 'react-redux'
import pageLocal from '../../helpers/TravelLocation'

class ChinaStoreLocator extends Component {
    constructor(props) {
        const {
            storeData: {
                storeData: {
                    location,
                    store,
                    options: { initialZoom },
                },
            },
        } = props
        super(props)
        this.state = {
            showErrorMessage: false,
            center: {
                lat: Number(location.lat),
                lng: Number(location.lng)
            },
            isMobile: null,
            zoom: initialZoom,
            clusterClick: false,
            storeList: [],
            showList: false,
            showError: false,
            selectedStore: null,
            triggerUpdate: false,
            detailShow: false,
            searchAddress: "",
            goBack: 'false'
        }
        this.mapRef = null
        this.allStores = store
        this.prevView = {}
        this.service = null
        this.map = null
        this.showRef = React.createRef(null)
        this.detailRef = React.createRef(null)
    }

    changeMarker = (marker, msg) => {
        const {
            storeData: {
                gaLabel,
                markerGaEventCategory,
                markerGaEventAction
            }
        } = this.props
        if (msg) {
            this.setState({
                goBack: true
            })
        }
        let point = new BMap.Point(marker.lan, marker.lat)
        this.mapRef.map.centerAndZoom(point, 14)
        this.setState({
            selectedStore: marker,
            detailShow: true,
            triggerUpdate: true,
            showList: true,
            // storeList: marker
        })
        // eslint-disable-next-line no-undef
        dataLayer.push({
            event: "customEvent",
            GAeventCategory: `${markerGaEventCategory}`,
            GAeventAction: `${markerGaEventAction}`,
            GAeventLabel: `${gaLabel}_click_location tag`
        })
    }

    goBack = () => {
        this.setState({
            goBack: false
        })
    }

    determineResiz = () => {
        this.setState({
            isMobile: window.innerWidth < breakpoints.sP ? true : false
        })
    }

    findCurrentCountry = () => {
        const { storeData: { countriesCollection }, countrySelector } = this.props
        const currentCountry = countriesCollection.items.find((eachCountry) => eachCountry.regionName === countrySelector.country)
        return currentCountry
    }

    componentDidMount() {
        const currentCountry = this.findCurrentCountry()
        const {
            storeData: {
                storeData: {
                    location,
                },
            },
        } = this.props
        this.setState({
            isMobile: window.innerWidth < breakpoints.sP ? true : false,
            center: {
                lat: Number(currentCountry.location ? currentCountry.location.lat : location.lat),
                lng: Number(currentCountry.location ? currentCountry.location.lon : location.lng),
            },

        })
        window.addEventListener("resize", this.determineResiz)
        if (typeof window != "undefined") {
            window.addEventListener("resize", () => {
                this.setState({
                    triggerUpdate: true
                })
            })
            const { pageReview } = this.props.storeData
            const localRegoin= pageLocal(this.props.countrySelector.country)
            if (!window.dataLayer.find(item => item.GAeventLabel === `${localRegoin}_${pageReview}`)) {
                // eslint-disable-next-line no-undef
                dataLayer.push({
                    'event': 'customEvent',
                    'GAeventCategory': 'event_informational_action',
                    'GAeventAction': 'event_view_page',
                    'GAeventLabel': `${localRegoin}_${pageReview}`,
                    'GAeventValue': 0,
                    'GAeventNonInteraction': true
                })
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.determineResiz)

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.center !== prevState.center)
            this.prevView.center = prevState.center
        if (this.state.zoom !== prevState.zoom)
            this.prevView.zoom = prevState.zoom
    }

    onLoadMap = ref => {
        this.mapRef = ref
        if (navigator) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    let latLngObj = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }
                    let point = new BMap.Point(latLngObj.lng, latLngObj.lat)
                    this.mapRef.centerAndZoom(point, 14)
                    this.mapRef.panTo(point)
                    let geocoder = new BMap.Geocoder()
                    geocoder.getLocation(point, results => {
                        if (results) {
                            this.setState({
                                searchAddress: results.address
                            })
                        } else {
                            window.alert("No results found")
                        }
                    })
                }
            )
        }
    }

    onSearchRelocate = searchAddress => {
        let pp = new BMap.Point(searchAddress.lan, searchAddress.lat)
        this.mapRef.map.centerAndZoom(pp, 14)
        let marker = new BMap.Marker(pp)
        this.mapRef.map.addOverlay(marker)
        this.setState({
            selectedStore: searchAddress,
            detailShow: true,
        })
    }

    onSearchCity = (searchAddress, cityStores,zoom=14) => {
        let pp = new BMap.Point(searchAddress.lon, searchAddress.lat)
        this.mapRef.map.centerAndZoom(pp, zoom)
        this.setState({
            detailShow: false,
            showList: true,
            storeList: cityStores.store,
        })
    }

    onCloseStoreDetail = () => {
        this.setState({
            detailShow: false,
            triggerUpdate: true,
            selectedStore: null,
            storeList: [],
            crossIcon: false,
            center: this.prevView.center,
            zoom: this.prevView.zoom,
        })
    }

    hideList = () => {
        this.setState({
            showList: false
        })
    }

    removeList = () => {
        this.setState({
            storeList: [],
            showList: true,
            detailShow: false,
            showError: false
        })
    }

    detailShowFunction = () => {
        this.setState({
            detailShow: !this.state.detailShow
        })
    }

    showListFunction = () => {
        this.setState({
            showList: false
        })
    }

    showErrorFunc = () => {
        this.setState({
            showError: true
        })
    }

    scrollToList = () => {
        const { isMobile } = this.state
        let offset = isMobile ? 120 : 10 // sticky nav height
        let el = document.querySelector('.store-details') // element you are scrolling to
        window.scroll({ top: (el.offsetTop - offset), left: 0, behavior: 'smooth' })
        // this.showRef.current.scrollIntoView({
        //     behaviour: "smooth"
        // })
    }

    scrollToDetail = () => {
        this.detailRef.current.scrollIntoView({
            behaviour: "smooth"
        })
    }

    updateStore = async () => {
        const {
            storeData: {
                storeData: {
                    options: { zoomOnMarkerClick }
                }
            }
        } = this.props
        if (this.mapRef && this.state.selectedStore) {
            let storepoint = new BMap.Point(this.state.selectedStore.lan, this.state.selectedStore.lat)
            let currentZoom = this.mapRef.map.getZoom()
            let currentCenter = this.mapRef.map.getCenter()
            if (currentZoom < zoomOnMarkerClick && storepoint != currentCenter) {
                this.setState({
                    detailShow: false,
                    triggerUpdate: true,
                    selectedStore: null,
                    storeList: []
                })
            }
        }
    }

    goBackFunction = () => {
        this.setState({
            showList: true,
            // storeList:
            detailShow: false
        })
    }

    render() {
        const { apiKey } = this.props
        const {
            storeData: {
                storeData: {
                    bounds,
                    store,

                },
                countriesCollection,
                placeholderMessage,
                errorMessageEmpty,
                errorMessageInvalid,
                directions,
                foundStorePart1,
                foundStorePart2
            }
        } = this.props
        const currentCountry = this.findCurrentCountry()
        const {
            center,
            zoom,
            storeList,
            searchAddress,
            selectedStore,
            detailShow,
            showList,
            isMobile,
            showError,
            goBack
        } = this.state

        let storeListAll = []
        store.map(val => {
            storeListAll.push({
                name: val.name,
                add: val.add,
                ph: val.ph,
                lat: val.lat,
                lng: val.lan,
                result: val.name + " " + val.add
            })
        })
        return (
            <div className={styles.topWrapper}>
                {!isMobile && (
                    <div className={styles.mapWrapper} id='map'>
                        <Map
                            mapStyle={mapStyle}
                            zoom={zoom}
                            apiKey={apiKey}
                            center={center}
                            isMobile={isMobile}
                            onLoadMap={this.onLoadMap}
                            changeMarker={this.changeMarker}
                            allStores={this.allStores}
                            updateStore={this.updateStore}
                        />
                    </div>
                )}
                <div
                    className={
                        styles.rightPanel + ((storeList.length === 0) ? ' centeraligned' : ' searchTopFix search-error')}
                >
                    <SearchBox
                        searchAddress={searchAddress}
                        countryBounds={bounds}
                        callBack={this.onSearchRelocate}
                        callBackCity={this.onSearchCity}
                        placeholderMessage={placeholderMessage}
                        storeList={storeListAll}
                        isMobile={isMobile}
                        errorMessageEmpty={errorMessageEmpty}
                        errorMessageInvalid={errorMessageInvalid}
                        hideList={this.hideList}
                        removeList={this.removeList}
                        options={store}
                        detailShow={this.detailShowFunction}
                        countrySelector={currentCountry}
                        countriesCollection={countriesCollection}
                        showList={this.showListFunction}
                        showError={this.showErrorFunc}
                        goBack={this.goBack}
                    />

                    {isMobile && (
                        <div className={styles.mapWrapperMob} id='map'>
                            <Map
                                mapStyle={mapStyle}
                                zoom={zoom}
                                center={center}
                                apiKey={apiKey}
                                onLoadMap={this.onLoadMap}
                                changeMarker={this.changeMarker}
                                allStores={this.allStores}
                                isMobile={isMobile}
                                updateStore={this.updateStore}

                            />
                        </div>
                    )}
                    {!detailShow && showList &&
                        <div className={!showError ? styles.storeDetailsWrapper : styles.storeDetailsWrappererror}>
                            <div ref={this.showRef} />
                            <StoreList
                                storeList={storeList}
                                callBack={this.changeMarker}
                                directions={directions}
                                foundStorePart1={foundStorePart1}
                                foundStorePart2={foundStorePart2}
                                scrollToList={this.scrollToList}
                            />
                        </div>
                    }
                    {detailShow &&
                        <div className={styles.storeDetailsWrapper}>
                            <div ref={this.detailRef} />
                            <StoreDetails
                                selectedStore={selectedStore}
                                scrollToList={this.scrollToDetail}
                                callBack={this.onCloseStoreDetail}
                                goBack={goBack}
                                goBackFunction={this.goBackFunction}
                            />
                        </div>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        countrySelector: state.changeCountryReducer
    }
}

export default connect(mapStateToProps)(ChinaStoreLocator)
